export default "__VITE_ASSET__vFJACEgv__"